/* eslint-disable react/no-array-index-key */
import React, { useEffect, useMemo, useState } from 'react';
import { TextField } from '@material-ui/core';
import { StyledKakarikoText } from './styles';

import type { IKakarikoTextProps } from './types';

export const KakarikoText = (props: IKakarikoTextProps) => {
  const {
    autoFocus,
    className = '',
    errorMessage,
    handleBlur,
    handleChange,
    hasError,
    isEditable,
    isEditing = true,
    placeholder = '',
    label = '',
    max,
    min,
    name,
    names,
    styles = {},
    tabIndex,
    type,
    value,
    variant,
    width = 'full',
  } = props;

  const isValueArray = useMemo(() => Array.isArray(value), [value]);

  const [internalValue, setInternalValue] = useState<any>(
    !Array.isArray(value) ? [value] : value,
  );

  const [touched, setTouched] = useState(false);

  const handleChangeInternal = (value: string, index: number) => {
    internalValue[index] = value;
    setInternalValue([...internalValue]);
    if (handleChange) {
      if (isValueArray) handleChange(internalValue);
      else handleChange(internalValue[0]);
    }
  };

  useEffect(() => {
    setInternalValue(isValueArray ? value : [value]);
  }, [isEditing, isValueArray, value]);

  const handleBlurInternal = (value: any, index: number) => {
    setTouched(true);
    internalValue[index] = value.trim();
    setInternalValue([...internalValue]);
    if (handleBlur) handleBlur(value);
  };

  useEffect(() => {
    if (
      isValueArray &&
      internalValue.some(
        (value?: string) => value !== undefined || value !== '',
      )
    ) {
      setTouched(true);
    } else if (value !== undefined && value !== '') {
      setTouched(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const itemHasError = (name: string | undefined) =>
    hasError === true ||
    (typeof hasError === 'object' && name && hasError[name] === true);

  return (
    <StyledKakarikoText
      className={`${className}`}
      style={{ ...styles }}
      tabIndex={tabIndex}
      $width={width}
    >
      {isEditing && isEditable !== false
        ? internalValue.map((val: string, index: number) => (
            <TextField
              id={`${label}-${index}`.toLowerCase().replace(/\s+/g, '-')}
              autoFocus={autoFocus || false}
              error={
                touched &&
                (hasError === true || itemHasError(names?.[index]) === true)
              }
              InputProps={{ inputProps: { min, max } }}
              key={`${index}`}
              fullWidth
              label={label}
              name={name ?? names?.[index]}
              onBlur={(e) => handleBlurInternal(e.target.value, index)}
              onChange={(e) => handleChangeInternal(e.target.value, index)}
              placeholder={placeholder}
              required={hasError !== undefined}
              type={type}
              value={val || ''}
              variant={variant}
            />
          ))
        : internalValue.map((val: string, index: number) => (
            <div key={`${index}`}>{val}</div>
          ))}
      {hasError && touched && errorMessage && (
        <div className="error">{errorMessage}</div>
      )}
    </StyledKakarikoText>
  );
};

export default KakarikoText;
